export default __webpack_public_path__ + "static/Manoj-op-d65f6979865e83aae1d0bd2393f0ee2a.png";